import { Permission } from '../../../../shared/auth';
import {
  AssembleTrayIcon,
  AssignToCaseIcon,
  BuildCartNavIcon,
  CobotSetupIcon,
  ReleaseToDeconIcon,
  TrackAssetIcon,
  EntityManagementIcon,
  TrackerSetupIcon,
  UserRolesIcon,
  CaseScheduleIcon,
} from './icons';
import type { NavigationItem } from './types';

export type NavTranslator = (key: string) => string;

export const getNavigationItems = (t: NavTranslator): NavigationItem[] => [
  {
    to: '/assemble-tray',
    label: t('assembleTray'),
    sidebarLabel: 'Assemble',
    icon: <AssembleTrayIcon />,
    // Single entry point for both hospital and OEM tray identification.
    permissions: [Permission.TRAY_ASSEMBLER, Permission.TRAY_SCANNER],
    showForAdmin: true,
    isDesktopOnly: true,
  },
  {
    to: '/case-cart-assembly',
    label: t('buildCart'),
    sidebarLabel: 'Build Cart',
    icon: <BuildCartNavIcon />,
    permissions: [Permission.CART_BUILDER],
    showForAdmin: true,
  },
  {
    to: '/case-schedule',
    label: t('caseSchedule'),
    sidebarLabel: 'Case Schedule',
    icon: <CaseScheduleIcon />,
    permissions: [Permission.OR_NURSE],
    showForAdmin: true,
  },
  {
    to: '/assign-to-case',
    label: t('assignToCase'),
    sidebarLabel: 'Assign',
    icon: <AssignToCaseIcon />,
    permissions: [Permission.OR_ASSIGN],
    showForAdmin: true,
  },
  {
    to: '/release-from-case',
    label: t('releaseToDecon'),
    sidebarLabel: 'Release',
    icon: <ReleaseToDeconIcon />,
    permissions: [Permission.SPD_RELEASE],
    showForAdmin: true,
  },
  {
    to: '/find-asset',
    label: t('trackAsset'),
    sidebarLabel: 'Find',
    icon: <TrackAssetIcon />,
    permissions: [Permission.ASSET_FINDER],
    showForAdmin: true,
  },
  {
    to: '/entity-management',
    label: t('entityManagement'),
    sidebarLabel: 'Entity',
    icon: <EntityManagementIcon />,
    permissions: [Permission.IMPLEMENTATION_ENGINEER],
    showForAdmin: true,
  },
];

export const getAdminNavigationItems = (t: NavTranslator): NavigationItem[] => [
  {
    to: '/user-roles',
    label: t('userRoles'),
    sidebarLabel: t('userRoles'),
    icon: <UserRolesIcon />,
    adminOnly: true,
  },
  {
    to: '/cobot-setup',
    label: t('cobotSetup'),
    sidebarLabel: t('cobotSetup'),
    icon: <CobotSetupIcon />,
    adminOnly: true,
  },
  {
    to: '/tracker-setup',
    label: t('trackerSetup'),
    sidebarLabel: t('trackerSetup'),
    icon: <TrackerSetupIcon />,
    adminOnly: true,
  },
];

export const getBottomNavigationItems = (): NavigationItem[] => [];
